import React, { useRef } from 'react'
import './home.css'
import Navigation from '../../components/navigation'
import Footer from '../../components/footer'
import { THEMES } from '../../constatnts'
import { Button } from 'src/components/button'
import Spacer from 'src/components/Spacer'
import PromoBlock from 'src/components/PromoBlock'
import { Link, useNavigate } from 'react-router-dom'
import CountUp from 'react-countup'
import { useIsInViewportOnce } from 'src/hooks'
import { Dialog, Grow, Slide, Zoom, Button as MuiButton } from '@mui/material'
import { useTranslation } from 'react-i18next';
import { LogoCyberly } from 'src/components/logo'

const Intersector = ({ children }) => {
  const someRef = useRef(null)
  const isInViewport = useIsInViewportOnce(someRef);

  return <div ref={someRef}>{isInViewport && children}</div>
}

const productProps = [
  { num: '01', text: 'Access to sensitive systems' },
  { num: '02', text: 'Analyzing Adam co-workers' },
  { num: '03', text: 'Matchmaking phishing trends to personalize simulations' },
  { num: '04', text: 'Launching anonymous simulations for audit' },
  { num: '05', text: 'Detect Adam vulnerability patterns, risks #passwords, #servers, #bitbucket' },
  { num: '06', text: 'spoofing simulation test #bitbucket, #passwords, #co-worker request' },
  { num: '07', text: 'Intention to report simulation' },
  { num: '08', text: 'Microtraining engagement' },
  { num: '09', text: 'Knowledge test' },
]

export const HomePage = () => {
  const { t } = useTranslation()


  return (
    <>
      <Navigation theme={THEMES.dark} />
      <section className='dark heading-section gradient5'>
        <div className='container'>
          <div className='row row-center mob-column-reverse mob-column-center'>
            <div className='column column-start one-of-2 mob-fullwidth mob-column-center' style={{ maxWidth: '470px' }}>
              <h1 className='mob-text-center' style={{ textShadow: '2px 2px 12px black' }}>
                {t('home.title')}
              </h1>

              <p className='mob-text-center heading-description mw371 mom-mw305' style={{ marginTop: '33px' }}>
                {t('home.subtitle')}
              </p>
              <Link to="https://admin.cyberlift.ai/registration">

                <Button variant={'gradient-button'} >{t('Get started')} <svg style={{ marginLeft: '20px' }} width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75L1 5.25ZM13.5303 6.53033C13.8232 6.23744 13.8232 5.76256 13.5303 5.46967L8.75736 0.696699C8.46447 0.403806 7.98959 0.403806 7.6967 0.696699C7.40381 0.989593 7.40381 1.46447 7.6967 1.75736L11.9393 6L7.6967 10.2426C7.40381 10.5355 7.40381 11.0104 7.6967 11.3033C7.98959 11.5962 8.46447 11.5962 8.75736 11.3033L13.5303 6.53033ZM1 6.75L13 6.75V5.25L1 5.25L1 6.75Z" fill="#E3E3FF" />
                </svg>
                </Button>
              </Link>
            </div>
            <div className='mob-hide' style={{ position: 'relative' }}>
              <img style={{ margin: '-150px -116px -110px 0px', animationDuration: '1s', animationName: 'apear' }} src="/images/ai-powered-sim-b.png" width="665" alt="" />
              <img style={{ position: 'absolute', left: -85, bottom: 27, animationDuration: '3s', animationName: 'slidein2' }} width={304} src="/images/p1.png" alt="" />
              <img style={{ position: 'absolute', left: 71, bottom: -91, animationDuration: '2s', animationName: 'slidein' }} width={304} src="/images/p2.png" alt="" />

            </div>
            <img className='hide mob-show' style={{ marginTop: '-80px' }} src="/images/mob-ai-powered-sim.png" width="375" alt="" />
          </div>
        </div>
      </section>
      <section className='header-to-dark darker padding140-150 box-shadow'>
        <div className='container'>
          <div className='column column-center'>
            <h2 className='text-center mb100 mob-mb-73 mw900 mob-mw341 mob-sato-26'>{t('home.setction2title')}</h2>

          </div>
          <div className='row space-between mob-column margin--40 mob-margin-0'>
            <div className='column column-center one-of-4 mob-fullwidth mob-mb-40'>
              <div className='gradient-text text-center big-num mb40 mob-mb-20'> <Intersector><CountUp end={93} />%</Intersector></div>
              <p className='text-center font16 mob-font14 mob-font500 mw279'>{t('home.setction2text1')}</p>
            </div>

            <div className='column column-center one-of-4 mob-fullwidth mob-mb-40'>
              <div className='gradient-text text-center big-num mb40 mob-mb-20'><Intersector><CountUp end={82} />%</Intersector></div>
              <p className='text-center font16 mob-font14 mob-font500 mw339 mob-mw299'>{t('home.setction2text2')}</p>
            </div>

            <div className='column column-center one-of-4 mob-fullwidth mob-mb-20'>
              <div className='gradient-text text-center big-num mb40 mob-mb-20'><Intersector><CountUp duration={3} end={30} />%</Intersector></div>
              <p className='text-center font16 mob-font14 mob-font500 mw279 mob-mw245'>{t('home.setction2text3')}</p>
            </div>

            <div className='column column-center one-of-4 mob-fullwidth mob-mb-20'>
              <div className='gradient-text text-center big-num mb40 mob-mb-20'><Intersector>$<CountUp duration={3} end={4} />.45M</Intersector></div>
              <p className='text-center font16 mob-font14 mob-font500 mw279 mob-mw245'>{t('home.setction2text4')}</p>
            </div>
          </div>

        </div>
      </section>
      <section className='dark padding140-150 mob-padding-82-0-102'>
        <div className='container1080'>
          <div className='row space-between mob-column'>
            <div className='one-of-2 mob-fullwidth pr50 mob-pad-0'>
              <p className='sato30 mob-font22 mob-mb-60' style={{ maxWidth: '440px' }}>
                {t('home.section3title')}
              </p>
            </div>
            <div className='column one-of-2 mob-fullwidth'>
              <div className='row mb20'>
                <div className='mr10'>
                  <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M26.4276 25.2503V25.2503C26.4276 21.1719 23.1214 17.8657 19.0429 17.8657H7.96274C3.88433 17.8657 0.578125 21.1719 0.578125 25.2503V25.2503" stroke="white" strokeWidth="0.923135" />
                    <ellipse cx="13.4984" cy="7.40385" rx="6.15463" ry="6.15385" stroke="white" strokeWidth="0.923135" />
                  </svg>

                </div>
                <div className='column'>
                  <p style={{ fontWeight: '700', marginBottom: '10px' }}>Adam Smith</p>
                  <p className='mob-font-14'>{t('Engineering team, Australia remote')}</p>
                </div>
              </div>

              <div className='column'>
                <div className='row'></div>
                {productProps.map((el, index) => <div key={el.num} className='column'>
                  <div style={{ color: '#CECEFF', marginBottom: '14px', marginTop: '14px' }} className='row font13 mob-font12'>
                    <span style={{ marginRight: '18px' }}>{el.num}</span>
                    <Intersector>
                      {/* <Grow mountOnEnter={true} in={true} timeout={(index + 1) * 500}> */}
                      <p>
                        {t('home.' + el.text)}
                      </p>
                      {/* </Grow> */}
                    </Intersector>
                  </div>
                  <div style={{ width: '100%' }} className='risk-ranging-line'></div>

                </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Dialog
        maxWidth={1000}
        sx={{
          '& .MuiBackdrop-root': { backdropFilter: 'blur(2px)' },
          '& .MuiPaper-root': { borderRadius: '22px', padding: '35px 30px' },
        }}
        open
      >
        <div className='row mob-column cyberly-banner' style={{ padding: '25px 20px', gap: 20 }}>
          <div className='column'>
            <LogoCyberly />

            <p style={{ fontSize: 18, fontWeight: 600, color: '#170C66', marginTop: 32, marginBottom: 12 }}>We're Now <a style={{ textDecoration: 'none', color: '#0049FF' }} href='https://cyberly.ai'>Cyberly.ai</a></p>

            <p style={{ color: '#170C66', fontSize: 14, lineHeight: '140%', maxWidth: 300, marginBottom: 10 }}>
              Cyberlift is rebranding to Cyberly — bringing you the same trusted team, the same security-first approach, and a powerful new platform experience.
            </p>
            <p style={{ color: '#170C66', fontSize: 14, lineHeight: '140%', maxWidth: 305, marginBottom: 10 }}>
              There’s no action required — all your existing portals and services continue to work as usual.
            </p>
            <p style={{ color: '#170C66', fontSize: 14, lineHeight: '140%', maxWidth: 305, marginBottom: 10 }}>
              Access your services:
            </p>

            <p style={{ color: '#170C66', fontSize: 14, lineHeight: '140%', maxWidth: 305 }}>• Admin Portal  →  <a style={{ textDecoration: 'none', color: '#0049FF' }} href='https://admin.cyberly.ai'>admin.cyberly.ai</a></p>
            <p style={{ color: '#170C66', fontSize: 14, lineHeight: '140%', maxWidth: 305, marginBottom: 20 }}>• Employee App  →  <a style={{ textDecoration: 'none', color: '#0049FF' }} href='https://app.cyberlift.ai'>app.cyberlift.ai</a> (existing)  or <a style={{ textDecoration: 'none', color: '#0049FF' }} href='https://app.cyberly.ai'>app.cyberly.ai</a>  (new)</p>

            <MuiButton
              variant='contained'
              sx={{
                background: '#0049FF',
                textTransform: 'none'
              }}
              onClick={() => {
                window.open('https://cyberly.ai')
              }}
            ><p>Explore what’s new at <span style={{ fontWeight: 600 }}> Cyberly</span></p> </MuiButton>


          </div>
          <Spacer />
          <div className='column'>
            <img src="images/dashboard.png" className='cyberly-dashboard' alt="" />
          </div>
        </div>
      </Dialog>
    </>
  )
}